( function( app, core, common ) {
    'use strict';

    const TEMPLATES = {
        KNOCKOUTS_LIST: 'fixtures.fixture-list',
        KNOCKOUTS_TEAM_A: 'fixtures.fixture-team-a',
        KNOCKOUTS_TEAM_B: 'fixtures.fixture-team-b',
        KNOCKOUTS_SCORE: 'fixtures.fixture-score'
    };

    const MILLISECONDS = {
        POINT_THREE_SECONDS: 300,
        THIRTY_SECONDS: 30000,
        SIX_HOURS: 216000000,
        ONE_SECOND: 1000
    };

    const STATUS = {
        UPCOMING: 'U',
        LIVE: 'L',
        FIRST_HALF: 'L1',
        SECOND_HALF: 'L2',
        OVERTIME_FIRST_HALF: 'L3',
        OVERTIME_SECOND_HALF: 'L4',
        HALF_TIME: 'LHT',
        FULL_TIME: 'LFT',
        COMPLETE: 'C',
        POSTPONED: 'UP'
    }

    app.Knockouts = function( widget ) {
        const _self = this;

        const hideTabs = document.querySelector( '.js-hide-tabs' );
        const knockOutTabs = document.querySelector( '.js-knockout-tabs' );

        if ( hideTabs && knockOutTabs ) {
            core.style.addClass( knockOutTabs, 'u-hide' );
        } else {
            _self.container = widget;
            _self.knockouts = document.querySelectorAll('.js-knockouts');
            _self.knockoutList = document.querySelectorAll( '.js-knockout-list' );
            _self.genderTabs = document.querySelectorAll( '.js-gender-tab' );
            _self.phaseTabs = document.querySelectorAll( '.js-phase-tab' );
            _self.times = document.querySelectorAll( '.js-ko-time' );
            _self.loader = document.querySelector('.isLoading');
    
            const womensKnockout = document.querySelector( '[data-event-gender="women"]' );
            _self.womensId = womensKnockout ? womensKnockout.dataset.eventId : '';
            const mensKnockout = document.querySelector( '[data-event-gender="men"]' );
            _self.mensId = mensKnockout ? mensKnockout.dataset.eventId : '';

            _self.pollingAttributes = document.querySelectorAll( '[data-polling]' );
            _self.fixtureModal = document.querySelector('.js-fixture-modal');
            _self.eventCode = _self.container.dataset.event || '';

            const url = window.location.search;
            setTimeout(() => {
                _self.events = common.openMatchInUrl( url, _self.container, true );
            }, MILLISECONDS.ONE_SECOND);

            _self.updateTime();
            _self.setListeners();
            _self.checkPollingStatus();
        }
    };

    app.Knockouts.prototype.getFixtures = async function () {
        const _self = this;
    
        const params = { language: app.language };
        const urls = [ common.endpoints.rugby.event.schedule(_self.mensId, params), common.endpoints.rugby.event.schedule(_self.womensId, params) ];
        const menFetch = fetch( urls[0]).then((response) => response.json() );
        const womenFetch = fetch( urls[1]).then((response) => response.json() );
        const [ menRes, womenRes ] = await Promise.all( [ menFetch, womenFetch ] );

        if ( menRes.matches && womenRes.matches ) {
            const mergeMatches = [ ...menRes.matches, ...womenRes.matches ];
            if ( mergeMatches.length > 0 ) {   
                const sortedMatches = mergeMatches.sort( ( a, b ) => {
                    if ( a.time.millis < b.time.millis ) {
                        return -1;
                    }
                    if ( a.time.millis > b.time.millis ) {
                        return 1;
                    }
                    return 0;
                });            
                
                sortedMatches.forEach( ( match, idx ) => {
                    _self.getPollingTimeframe( match, idx );
                });
                _self.polling();
            }
        }
    }

    app.Knockouts.prototype.checkPollingStatus = function () {
        const _self = this;

        if ( !_self.womensId || !_self.mensId ) {
            return;
        }

        let isPolling = false;
        _self.pollingAttributes.forEach( attr => {
            attr.dataset.polling === 'true' ? isPolling = true : isPolling;
        } )  

        if ( !isPolling ) {        
            _self.container.dataset.polling = 'true';
            _self.getFixtures();
        }
    }

    app.Knockouts.prototype.polling = function () {
        const _self = this;

        let now = new Date().getTime();
        if ( now > _self.startPolling && now < _self.endPolling ) {
            _self.polling = setInterval( () => {
                _self.getUpdates();
            }, MILLISECONDS.THIRTY_SECONDS );
        }
    }

    app.Knockouts.prototype.getPollingTimeframe = function ( match, idx ) {
        const _self = this;

        if ( idx === 0 ) {
            _self.startPolling = match.time.millis - MILLISECONDS.SIX_HOURS;
            _self.endPolling = match.time.millis + MILLISECONDS.SIX_HOURS;
        } else {
            if ( match.time.millis - MILLISECONDS.SIX_HOURS < _self.startPolling ) {
                _self.startPolling = match.time.millis - MILLISECONDS.SIX_HOURS;
            } else if ( match.time.millis + MILLISECONDS.SIX_HOURS > _self.endPolling ) {
                _self.endPolling = match.time.millis + MILLISECONDS.SIX_HOURS;
            }
        }
    }

    app.Knockouts.prototype.getUpdates = async function () {
        const _self = this;

        const params = { language: app.language };
        const urls = [ common.endpoints.rugby.event.schedule( _self.mensId, params ), common.endpoints.rugby.event.schedule( _self.womensId, params ) ];
        const menFetch = fetch( urls[0] ).then( response => response.json() );
        const womenFetch = fetch( urls[1] ).then( response => response.json() );
        const [ menRes, womenRes ] = await Promise.all( [menFetch, womenFetch] );

        if ( menRes.matches && womenRes.matches ) {
            const mergeMatches = [...menRes.matches, ...womenRes.matches];
            _self.updateFixtureList( mergeMatches );
        }
    }

    app.Knockouts.prototype.updateFixtureList = async function ( mergeMatches ) {
        const _self = this;

        mergeMatches.forEach( newDataItem => {

            const fixtureInfo = document.querySelectorAll( '.js-fixture-item' );
            fixtureInfo.forEach( templateItem => {

                if ( templateItem.dataset.matchId === newDataItem.matchId ) {                    
                    
                    const teamA = templateItem.querySelector('.js-team-a');
                    const teamB = templateItem.querySelector('.js-team-b');
                    const newTeamA = newDataItem.teams[0].abbreviation || '';
                    const newTeamB = newDataItem.teams[1].abbreviation || '';

                    if ( teamA && teamA.dataset.team !== newTeamA ) {

                        const model = {
                            abbrv: newTeamA,
                            name: newDataItem.teams[0].name || '',
                            eventCode: _self.eventCode,
                            parentClass: 'knockout-list'
                        }
                        teamA.innerHTML = app.templating.render( model, TEMPLATES.KNOCKOUTS_TEAM_A );
                        teamA.dataset.team = newTeamA;
                    }

                    if ( teamB && teamB.dataset.team !== newTeamB ) {

                        const model = {
                            abbrv: newTeamB,
                            name: newDataItem.teams[1].name || '',
                            eventCode: _self.eventCode,
                            parentClass: 'knockout-list'
                        }
                        teamB.innerHTML = app.templating.render( model, TEMPLATES.KNOCKOUTS_TEAM_B );
                        teamB.dataset.team = newTeamB;
                    }

                    if ( templateItem.dataset.status !== newDataItem.status || newDataItem.status.includes( STATUS.LIVE ) ) {
                        const matchId = newDataItem.matchId || '0';
                        _self.updateScores( matchId, templateItem, mergeMatches );
                    }
                }
            } )
        } )
    }

    app.Knockouts.prototype.updateScores = async function ( matchId, templateItem, mergeMatches ) {
        const _self = this;

        const params = { language: app.language };
        const urls = [ common.endpoints.rugby.match.summary( matchId, params ), common.endpoints.rugby.match.timeline( matchId, params ) ];
        const summary = fetch( urls[0] ).then( response => response.json() );
        const timeline = fetch( urls[1] ).then( response => response.json() );
        const [ summaryRes, timelineRes ] = await Promise.all( [ summary, timeline ] );
        const match = summaryRes.match || [];

        const scores = templateItem.querySelector('.js-scores') || '';
        const versus = templateItem.querySelector('.js-versus') || '';
        const scoreA = templateItem.querySelector('.js-score-a') || '';
        const scoreB = templateItem.querySelector('.js-score-b') || '';
    
        const scoreChange = scoreA && scoreA.dataset.score !== match.scores[0].toString() || scoreB && scoreB.dataset.score !== match.scores[1].toString();
        const statusChange = templateItem.dataset.status && templateItem.dataset.status !== match.status;

        const matchStarted = match.status !== STATUS.UPCOMING && match.status !== STATUS.POSTPONED;
        if ( matchStarted && versus ) {
            core.style.addClass( versus, 'u-hide' );
        }
    
        if ( scoreChange || statusChange ) {
            const model = {
                scoreA: match.scores[0] || '0',
                scoreB: match.scores[1] || '0',
                status: match.status,
                parentClass: 'knockout-list'
            }
            if ( scores ) {
                scores.innerHTML = app.templating.render( model, TEMPLATES.KNOCKOUTS_SCORE );
            }
        }

        if ( _self.fixtureModal && core.style.hasClass( _self.fixtureModal, 'isVisible' ) ) {
            _self.events = new app.MatchPolling( match, summaryRes, timelineRes, _self.events, true );
        }
    }

    app.Knockouts.prototype.updateTime = function ( ) {
        const _self = this;

        _self.times.forEach( time => {
            const koTime = moment( parseInt( time.dataset.clock ) ).format('h:mm A') + '*';
            time.innerHTML = koTime;
        } )    

        _self.times.forEach( time => {
            core.style.removeClass( time, 'u-hide' );
        } )      
    }

    app.Knockouts.prototype.setListeners = function () {
        const _self = this;

        if( _self.phaseTabs.length > 0 ) {
            _self.phaseTabs.forEach( tab => {
                tab.addEventListener( 'click', () => {
                   const phase = tab.dataset.phase;
                   let gender ='';
                   _self.genderTabs.forEach( ( item ) => {
                       if( core.style.hasClass( item, 'isActive' )) {
                           gender = item.dataset.gender;
                       }
                   } );
                    const matches = document.querySelectorAll( `[data-phase="${ phase }"][data-gender="${ gender }"]` )
                   
                    _self.knockouts.forEach( item => {
                       core.style.addClass( item, 'u-hide' )
                   } );

                   matches.forEach( match => {
                       core.style.removeClass( match, 'u-hide' );
                   } );
                   _self.setTabs( phase, gender )
                } );
            } );
        }

        if( _self.genderTabs.length > 0 ) {
            _self.genderTabs.forEach( tab => {
                tab.addEventListener( 'click', () => {
                   const gender = tab.dataset.gender;
                   let phase ='';
                   _self.phaseTabs.forEach( ( item ) => {
                       if( core.style.hasClass( item, 'isActive' )) {
                           phase = item.dataset.phase;
                       }
                   } );
                    const matches = document.querySelectorAll( `[data-phase="${ phase }"][data-gender="${ gender }"]` )
                   
                    _self.knockouts.forEach( item => {
                       core.style.addClass( item, 'u-hide' )
                   } );

                   matches.forEach( match => {
                       core.style.removeClass( match, 'u-hide' )
                   } );
                   _self.setTabs( phase, gender )
                } );
            } );
        }   
        
        const fixtureInfo = document.querySelectorAll('.js-fixture-item');
        fixtureInfo.forEach( item => {
            item.addEventListener( 'click', () => {
                const matchId = item.dataset.matchId;
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + `?matchId=${ matchId }&tab=timeline`;
                window.history.pushState({ path: refresh }, '', refresh);
                core.style.removeClass(_self.loader, 'u-hide' );

                _self.events = {
                    renderedCards: [],
                    renderedSubs: [],
                    renderedScoring: [],
                    renderedEvents: [],
                    renderedKoTape: [],
                    renderedHtTape: [],
                    renderedFtTape: []
                };
                _self.events = new app.MatchModal( matchId, _self.container, _self.events, true );
            });
        });
    };

    app.Knockouts.prototype.setTabs = function ( phase, gender ) {
        const _self = this;
        
        _self.phaseTabs.forEach( ( tab ) => {
            core.style.removeClass( tab, 'isActive' );
            const dataPhase = tab.dataset.phase;
            if( phase === dataPhase ) {
                core.style.addClass( tab, 'isActive' );
            }
        } );
        
        _self.genderTabs.forEach( ( tab ) => {
            core.style.removeClass( tab, 'isActive' );
            const dataGender = tab.dataset.gender;
            if( gender === dataGender ) {
                core.style.addClass( tab, 'isActive' );
            }
        } );
    }

    const widgets = document.querySelectorAll( '[data-widget="knockouts"]' );
    [].forEach.call( widgets, widget => new app.Knockouts( widget ) );

} ( PULSE.app, PULSE.core, PULSE.app.common ) );